import { render, staticRenderFns } from "./ModuleColors.vue?vue&type=template&id=9a2a3fd8&scoped=true&"
import script from "./ModuleColors.vue?vue&type=script&lang=js&"
export * from "./ModuleColors.vue?vue&type=script&lang=js&"
import style0 from "./ModuleColors.vue?vue&type=style&index=0&id=9a2a3fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2a3fd8",
  null
  
)

export default component.exports